import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  FormControl,
  FormLabel,
  Typography,
  withStyles
} from '@material-ui/core';
import clsx from 'clsx';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { bindActionCreators } from 'redux';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import { sendLogin } from '../../auth/Auth';
import SearchButton from '../../components/atoms/SearchButton';
import BudgetTableGroup from '../organisms/BudgetTableGroup';
import EditBudgetConfirmDialog from '../../components/molecules/EditBudgetConfirmDialog';
import BudgetConfirmDialog from './BudgetConfirmDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import {
  getGroupBudgets,
  GET_GROUP_BUDGETS_SUCCESS,
  postGroupBudgets,
  POST_GROUP_BUDGETS_SUCCESS,
  putGroupBudgets,
  PUT_GROUP_BUDGETS_SUCCESS
} from '../../actions/Budgets';

const styles = theme => ({
  root: {
    display: 'flex'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: '20px 0px',
    minWidth: 1024
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  // textField: {
  //   marginTop: 10
  // },
  subTitle: {
    fontWeight: '600',
    fontSize: 12,
    marginBottom: 10,
    color: '#000000'
  },
  rowForm: {
    display: 'flex',
    marginLeft: '-5px',
    marginRight: '-5px',
    flexWrap: 'wrap'
  },
  formControl: {
    paddingLeft: 5,
    paddingRight: 5,
    marginBottom: 15,
    width: '20%'
  },
  textField: {
    position: 'relative'
  },
  noPaddingCell: {
    padding: 0,
    border: 'none',
    paddingRight: 5,
    maxWidth: 200,
    minWidth: 200,
    verticalAlign: 'initial'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  tableContainer: {
    position: 'relative',
    marginTop: 15,
    paddingTop: 10
  },
  buttonGroupRight: {
    position: 'absolute',
    top: 0,
    right: 0
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  toolbar: {
    display: 'flex',
    fontSize: 24,
    fontWeight: 'bold'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: 'calc(100% - 240px)',
    minWidth: 1024
  },
  formLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#000'
  },
  textInput: {
    height: 1
  },
  buttonSearch: {
    marginLeft: 10,
    height: 38
  },
  modal: {
    maxWidth: 978,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  selectInput: {
    backgroundColor: '#FFF !important'
  },
  select: {
    width: '100%',
    // height: 38,
    height: '52%',
    // marginTop: 10,
    display: 'flex',
    backgroundColor: '#FFF'
  },
  inline: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      group: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getGroupBudgets, postGroupBudgets, putGroupBudgets },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('showPopupConfirm', 'setShowPopupConfirm', false),
  withState('budgetAmount', 'setBudgetAmount', ''),
  withState('budgetRowDetail', 'setBudgetRowDetail', null),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('budgetList', 'setBudgetList', []),
  withState('editBudgetMode', 'setEditBudgetMode', []),
  withState('filterYear', 'setFilterYear', () => {
    const today = new Date();
    return today.getFullYear();
  }),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    group,
    checkSession,
    actions,
    classes,
    filterYear,
    setFilterYear,
    budgetRowDetail,
    setBudgetRowDetail,
    showPopupConfirm,
    setShowPopupConfirm,
    budgetAmount,
    setBudgetAmount,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    budgetList,
    setBudgetList,
    setResultMessage,
    editBudgetMode,
    setEditBudgetMode
  }) => {
    function resetEdit() {
      setBudgetRowDetail(null);
      setEditBudgetMode([]);
      setBudgetAmount('');
    }
    function fillMonths(source) {
      const result = [];
      for (let i = 1; i <= 12; i += 1) {
        const found = source.find(item => item.month === i);
        if (!found) {
          result.push({
            month: i,
            year: filterYear
          });
        } else {
          result.push({ ...found });
        }
      }
      return result;
    }
    async function searchAction() {
      updateLoading(true);
      updateOpenProgress(true);
      actions
        .getGroupBudgets({
          groupId: group.groupId,
          year: filterYear,
          page: 1,
          limit: 12
        })
        .then(response => {
          checkSession(response);
          if (response.type === GET_GROUP_BUDGETS_SUCCESS) {
            setBudgetList(fillMonths(response.payload.budgets));
            resetEdit();
            updateOpenProgress(false);
            setResultMessage('');
          } else {
            setResultMessage(
              'インターネット接続には問題が発生しました。後でもう一度試してください。'
            );
          }
        })
        .catch(() => {
          setResultMessage(
            'インターネット接続には問題が発生しました。後でもう一度試してください。'
          );
        })
        .finally(() => {
          updateLoading(false);
        });
    }
    function progressOkAction() {
      updateOpenProgress(false);
      if (
        resultMessage !==
        'インターネット接続には問題が発生しました。後でもう一度試してください。'
      )
        searchAction();
      setResultMessage('');
    }
    const today = new Date();
    function generateYears() {
      const tmp = [{ value: '2021', label: '2021' }];
      const milestone = new Date('Jan 01, 2021');
      while (!(milestone.getFullYear() === today.getFullYear() + 1)) {
        milestone.setYear(milestone.getFullYear() + 1);
        tmp.push({
          value: parseInt(milestone.getFullYear(), 0),
          label: `${milestone.getFullYear()}`
        });
      }
      return tmp;
    }

    const options = generateYears();

    const actionOKConfirm = async () => {
      setShowPopupConfirm(false);
      updateLoading(true);
      updateOpenProgress(true);
      if (budgetRowDetail.budgetId) {
        actions
          .putGroupBudgets({
            budgetId: budgetRowDetail.budgetId,
            requestAmount: budgetAmount
          })
          .then(data => {
            checkSession(data);
            if (data.type === PUT_GROUP_BUDGETS_SUCCESS) {
              setResultMessage('予算修正が完了しました。');
              updateLoading(false);
            } else {
              setResultMessage('システムに問題が発生しました。');
              updateLoading(false);
            }
          })
          .catch(() => {
            setResultMessage('システムに問題が発生しました。');
            updateLoading(false);
          });
      } else {
        actions
          .postGroupBudgets({
            groupId: group.groupId,
            year: filterYear,
            month: budgetRowDetail.budgetMonth,
            requestAmount: budgetAmount
          })
          .then(data => {
            checkSession(data);
            if (data.type === POST_GROUP_BUDGETS_SUCCESS) {
              setResultMessage('予算修正が完了しました。');
              updateLoading(false);
            } else {
              setResultMessage('システムに問題が発生しました。');
              updateLoading(false);
            }
          })
          .catch(() => {
            setResultMessage('システムに問題が発生しました。');
            updateLoading(false);
          });
      }
    };

    useEffect(() => {
      searchAction();
    }, []);

    return (
      <>
        <div className={classes.root}>
          <MenuDrawerGroup title="EDIT BUDGET" />
          <main className={classes.content}>
            <div className={classes.toolbar} style={{ display: 'none' }} />

            <Typography variant="h6" noWrap className={classes.title}>
              予約確認
            </Typography>
            <Paper className={classes.paperWhite}>
              <div className={classes.searchForm}>
                <div className={classes.rowForm}>
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>
                      チケット種別
                    </FormLabel>
                    <div className={classes.inline}>
                      <Select
                        className={classes.textField}
                        variant="outlined"
                        size="small"
                        onChange={e => {
                          setFilterYear(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                        value={filterYear}
                      >
                        {options.map(option => {
                          return (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <SearchButton
                        customStyles={classes.buttonSearch}
                        onClickAction={searchAction}
                      />
                    </div>
                  </FormControl>
                </div>
              </div>
            </Paper>
            <div className={classes.tableContainer}>
              <BudgetTableGroup
                budgetList={budgetList}
                setShowPopupConfirm={setShowPopupConfirm}
                setBudgetRowDetail={setBudgetRowDetail}
                budgetRowDetail={budgetRowDetail}
                showPopupConfirm={showPopupConfirm}
                setBudgetAmount={setBudgetAmount}
                editBudgetMode={editBudgetMode}
                setEditBudgetMode={setEditBudgetMode}
                budgetAmount={budgetAmount}
              />
            </div>
          </main>
        </div>

        <EditBudgetConfirmDialog
          isOpen={
            showPopupConfirm && budgetRowDetail && budgetRowDetail.budgetId
          }
          okAction={actionOKConfirm}
          cancelAction={() => setShowPopupConfirm(false)}
          budgetAmount={budgetAmount}
          setBudgetAmount={setBudgetAmount}
          budgetRowDetail={budgetRowDetail}
          textOk="はい"
          textCancel="いいえ"
        />

        <BudgetConfirmDialog
          isOpen={
            showPopupConfirm && budgetRowDetail && !budgetRowDetail.budgetId
          }
          okAction={actionOKConfirm}
          cancelAction={() => setShowPopupConfirm(false)}
          budgetAmount={budgetAmount}
          budgetRowDetail={budgetRowDetail}
          textOk="はい"
          textCancel="いいえ"
        />

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
